import React from 'react';
import Card from '../../../components/ui/Card';
import Icon from '../../../components/AppIcon';
import Badge from '../../../components/ui/Badge';

const OptimizationInsights = ({ insights }) => {
  const getInsightIcon = (type) => {
    switch (type) {
      case 'warning':
        return 'AlertTriangle';
      case 'opportunity':
        return 'TrendingUp';
      case 'alert':
        return 'AlertCircle';
      default:
        return 'Info';
    }
  };

  const getInsightVariant = (type) => {
    switch (type) {
      case 'warning':
        return 'warning';
      case 'opportunity':
        return 'success';
      case 'alert':
        return 'danger';
      default:
        return 'default';
    }
  };

  const allInsights = insights?.flatMap(center => 
    center?.insights?.map(insight => ({
      ...insight,
      centerId: center?.centerId
    }))
  );

  if (allInsights?.length === 0) {
    return (
      <Card className="p-6">
        <div className="text-center py-8">
          <Icon name="CheckCircle" size={48} className="mx-auto text-green-500 mb-4" />
          <h3 className="text-lg font-semibold text-foreground mb-2">All Optimized!</h3>
          <p className="text-muted-foreground">No optimization opportunities detected at this time.</p>
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-foreground mb-2">Optimization Insights</h2>
        <p className="text-sm text-muted-foreground">
          AI-powered recommendations to maximize revenue per sqft
        </p>
      </div>

      <div className="space-y-4">
        {allInsights?.map((insight, index) => (
          <div
            key={index}
            className="flex items-start gap-4 p-4 border border-border rounded-lg hover:shadow-md transition-shadow"
          >
            <div
              className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                insight?.type === 'warning' ?'bg-yellow-100'
                  : insight?.type === 'opportunity' ?'bg-green-100' :'bg-red-100'
              }`}
            >
              <Icon
                name={getInsightIcon(insight?.type)}
                size={20}
                className={`${
                  insight?.type === 'warning' ?'text-yellow-600'
                    : insight?.type === 'opportunity' ?'text-green-600' :'text-red-600'
                }`}
              />
            </div>

            <div className="flex-1">
              <div className="flex items-start justify-between gap-2 mb-2">
                <p className="font-medium text-foreground">{insight?.centerId}</p>
                <Badge variant={getInsightVariant(insight?.type)} size="sm">
                  {insight?.impact} impact
                </Badge>
              </div>
              <p className="text-sm text-muted-foreground">{insight?.message}</p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default OptimizationInsights;